import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  updateResultPanelFailed,
  updateResultPanelSuccess,
  updateResultPanelStart,
} from "../redux/updateResultPanel";

import { toast } from "react-toastify";
import { updateResultApi } from "core/http/service/interviewSchedule";
import { getDetailInterviewStart } from "../redux/getDetailInterview";
import { SCREEN } from "helper/roleChecker/Screens";
import { getInfoSelectedCandidateDataSelector } from "../redux/selector";

function* updateResultPanelWork(
  action: ReturnType<typeof updateResultPanelStart>
) {
  const formData = yield select(getInfoSelectedCandidateDataSelector);
  const { callback, ...rest } = action.payload;
  try {
    const newForm = {
      applyInfoId: formData?.applyInfoId,
      communicatePoint: formData?.communicatePoint,
      appearancePoint: formData?.appearancePoint,
      demeanorPoint: formData?.demeanorPoint,
      implementationPlanPoint: formData?.implementationPlanPoint,
      experiencePoint: formData?.experiencePoint,
      expertiseKnowledgePoint: formData?.expertiseKnowledgePoint,
      averagePoint: formData?.averagePoint,
      reason: formData?.reason,
      status: formData?.panelParticipateStatus,
      evaluationStatus: formData?.result,
      scheduleId: rest?.scheduleId,
      ...rest,
    };

    const res = yield call(updateResultApi, newForm);
    if (res) {
      yield put({
        type: updateResultPanelSuccess.type,
      });

      yield put({
        type: getDetailInterviewStart.type,
        payload: {
          screenCode: SCREEN.IP_025,
          scheduleId: rest?.scheduleId,
        },
      });

      toast.success("Xác nhận thành công!");

      if (callback) {
        callback();
      }
    }
  } catch (error: any) {
    yield put({
      type: updateResultPanelFailed.type,
    });

    toast.error(error?.response?.data?.message || "Xác nhận thất bại!");
  }
}

function* watchUpdateResultPanel() {
  yield takeLatest(updateResultPanelStart.type, updateResultPanelWork);
}

export default function* updateResultPanelSaga() {
  yield all([watchUpdateResultPanel()]);
}
